import { useEffect } from 'react';
import useUserContext from '../../hooks/useUserContext';
import { getUserByUsername } from '../../services/userService';

/**
 * A component that handles joining user-specific notification channels
 * This is a "headless" component that doesn't render any UI elements
 */
const NotificationSetup: React.FC = () => {
  const { user, socket, updateUser } = useUserContext();

  useEffect(() => {
    if (socket && user) {
      socket.emit('joinUserRoom', user.username);

      socket.on('profilePictureUpdated', async data => {
        if (data.username === user.username) {
          updateUser({
            profilePicture: data.profilePicture,
          });

          try {
            const freshUserData = await getUserByUsername(user.username);
            if (freshUserData) {
              sessionStorage.setItem('currentUser', JSON.stringify(freshUserData));
            }
          } catch (error) {
            // silently handle errors
          }
        }
      });

      // Set up cleanup on unmount
      return () => {
        socket.emit('leaveUserRoom', user.username);
        socket.off('profilePictureUpdated');
      };
    }

    // Return an empty cleanup function when condition isn't met
    return () => {};
  }, [socket, user, updateUser]);

  // This component doesn't render anything
  return null;
};

export default NotificationSetup;
